import React from 'react';
import ReactDom from 'react-dom/client';

import './index.css'
import  App from './App' ;

import {BrowserRouter as Router} from 'react-router-dom';
import { StateProvider } from './Context/StateProvider';
import reducer from './Context/reducer';
import { initialState } from './Context/Initialstate';
 
const root = ReactDom.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Router>
            <StateProvider initialState={initialState} reducer={reducer}>
        <App/>
            </StateProvider>
        </Router>
    </React.StrictMode>
);


